// @ts-nocheck
import React, { FC, forwardRef, useRef } from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { styled } from "@mui/material/styles";
import { TooltipComponentProps } from "../../interface";

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  () => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "var(--primary-text)",
      color: "var(--surface-white)",
      fontSize: "14px",
      fontWeight: 500,
      padding: "8px 12px",
      borderRadius: "4px",
      gap: "8px",
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: "var(--primary-text)",
    },
  }),
);

const ToolTipComponent: FC<TooltipComponentProps> = forwardRef((props: TooltipComponentProps, ref) => {
  const tooltipRef = ref || useRef(null);

  return props.content ? (
    <StyledTooltip
      placement={props.position || "top"}
      TransitionComponent={Zoom}
      arrow
      title={
        <span ref={tooltipRef} style={{ gap: "8px" }}>
          {props.content}
        </span>
      }
    >
      <div>{props.children ?? <span />}</div>
    </StyledTooltip>
  ) : (
    props.children
  );
});

ToolTipComponent.displayName = "ToolTipComponent";
export default ToolTipComponent;
